<div class="client-report" (click)="$event.stopImmediatePropagation()">

  <!-- Period -->
  <div class="period" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
      <mat-icon class="muted">date_range</mat-icon>
      <div *ngIf="dateFrom && !editingPeriod">
        <div class="caption">{{ 'CLIENT_REPORT.PERIOD' | translate }}</div>
        <div class="period-value">{{ dateFrom }} – {{ dateTo }}</div>
      </div>
      <mat-form-field *ngIf="!dateFrom || editingPeriod" appearance="outline" class="period-picker">
        <mat-label>{{ 'CLIENT_REPORT.PERIOD' | translate }}</mat-label>
        <mat-date-range-input [formGroup]="periodForm" [rangePicker]="picker">
          <input matStartDate formControlName="start">
          <input matEndDate formControlName="end" (dateChange)="applyPickedPeriod()">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-hint>{{ 'CLIENT_REPORT.INCLUSIVE_HINT' | translate }}</mat-hint>
      </mat-form-field>
    </div>
    <button *ngIf="dateFrom && !editingPeriod" mat-button color="primary" (click)="editingPeriod = true">
      {{ 'CLIENT_REPORT.CHANGE_PERIOD' | translate }}
    </button>
  </div>

  <p *ngIf="!ready" class="muted">{{ 'CLIENT_REPORT.PICK_PERIOD_HINT' | translate }}</p>

  <ng-container *ngIf="ready">
    <form [formGroup]="texts">
      <section>
        <div class="section-head">
          <h3>{{ 'CLIENT_REPORT.INTRO' | translate }}</h3>
          <span class="chip">{{ 'CLIENT_REPORT.LANGUAGE' | translate }}: {{ defaults.language | uppercase }}</span>
        </div>
        <textarea formControlName="intro" rows="5" [attr.aria-label]="'CLIENT_REPORT.INTRO' | translate"></textarea>
      </section>

      <section>
        <div class="section-head">
          <h3>{{ 'CLIENT_REPORT.ACTIONS' | translate }}</h3>
          <span class="muted">{{ 'CLIENT_REPORT.SELECTED_COUNT' | translate: {count: selectedActions.size, total: actions.length} }}</span>
        </div>
        <mat-checkbox *ngFor="let item of actions" class="check-row"
                      [checked]="selectedActions.has(item.id)" (change)="toggleItem(selectedActions, item.id)">
          {{ item.title }}
        </mat-checkbox>
      </section>

      <section>
        <div class="section-head">
          <h3>{{ 'CLIENT_REPORT.NEXT_STEPS' | translate }}</h3>
          <span class="muted">{{ 'CLIENT_REPORT.SELECTED_COUNT' | translate: {count: selectedNextSteps.size, total: nextSteps.length} }}</span>
        </div>
        <mat-checkbox *ngFor="let item of nextSteps" class="check-row"
                      [checked]="selectedNextSteps.has(item.id)" (change)="toggleItem(selectedNextSteps, item.id)">
          {{ item.title }}
        </mat-checkbox>
      </section>

      <section>
        <div class="section-head">
          <h3>{{ 'CLIENT_REPORT.CONCLUSION' | translate }}</h3>
        </div>
        <textarea formControlName="conclusion" rows="4" [attr.aria-label]="'CLIENT_REPORT.CONCLUSION' | translate"></textarea>
      </section>
    </form>

    <section>
      <button type="button" class="section-head section-toggle" (click)="showPreview = !showPreview"
              [attr.aria-expanded]="showPreview">
        <h3>{{ 'CLIENT_REPORT.PREVIEW' | translate }}</h3>
        <span class="link">{{ (showPreview ? 'CLIENT_REPORT.COLLAPSE' : 'CLIENT_REPORT.SHOW_PREVIEW') | translate }}</span>
      </button>
      <div *ngIf="showPreview" class="preview">
        <iframe #frame [srcdoc]="previewHtml" sandbox="allow-same-origin" title="Report preview"
                (load)="fitPreview(frame)"></iframe>
        <div class="caption center">{{ 'CLIENT_REPORT.PREVIEW_HINT' | translate }}</div>
      </div>
    </section>

    <section>
      <div class="section-head">
        <h3>{{ 'CLIENT_REPORT.RECIPIENTS' | translate }}</h3>
      </div>
      <mat-form-field appearance="outline" class="recipients">
        <mat-label>{{ 'CLIENT_REPORT.EMAIL' | translate }}</mat-label>
        <mat-chip-list #chipList [attr.aria-label]="'CLIENT_REPORT.RECIPIENTS' | translate">
          <mat-chip *ngFor="let email of emails" [selectable]="false" [removable]="true" (removed)="removeEmail(email)">
            {{ email }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input [placeholder]="'CLIENT_REPORT.ADD_EMAIL' | translate"
                 [matChipInputFor]="chipList"
                 [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                 [matChipInputAddOnBlur]="true"
                 (matChipInputTokenEnd)="addEmail($event)">
        </mat-chip-list>
        <mat-hint *ngIf="!invalidEmail">{{ 'CLIENT_REPORT.RECIPIENTS_HELP' | translate }}</mat-hint>
        <mat-hint *ngIf="invalidEmail" class="error">{{ 'CLIENT_REPORT.INVALID_EMAIL' | translate: {email: invalidEmail} }}</mat-hint>
      </mat-form-field>
    </section>

    <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
      <button mat-button [disabled]="sending" (click)="reset()">{{ 'CLIENT_REPORT.RESET' | translate }}</button>
      <button mat-raised-button color="primary" [disabled]="sending || !emails.length" (click)="send()">
        {{ 'CLIENT_REPORT.SEND' | translate }}
      </button>
    </div>
  </ng-container>
</div>
